<template>
  <div class="h5-page-eianFAQ">
    <div class="main-title">
      <h1>环保小智使用功能</h1>
      <h1>常见问题及解决方案</h1>
      <h3>……内容持续更新中……</h3>
    </div>
    <div class="faq-div">
      <h3 @click="getLastData()">[<u>返回上一级</u>]</h3>
    </div>
    <div class="faq-div" v-for="(item, index) in questionList" :key="index">
      <template v-if="item.contents.length">
        <h3 @click="item.showCFlag = !item.showCFlag">
          [<u><span v-if="item.showCFlag">收起</span><span v-else>展开</span></u>]
          {{ item.title }}
        </h3>
        <template v-if="item.showCFlag">
          <p v-for="(cItem, cIndex) in item.contents" :key="cIndex">
            <span v-if="cItem.indexOf('http://' || 'https://') === -1">{{ cItem }}</span>
            <img v-else :src="cItem">
          </p>
        </template>
      </template>
      <template v-else>
        <h3 @click="getNextData(item)">
          [<u>点击前往</u>]{{ item.title }}
        </h3>
      </template>
    </div>
  </div>
</template>

<script>
import api from '../../api/index'
export default {
  data () {
    return {
      lastIdList: ['faq0'],
      lastId1: 155,
      // questionList: [{
      //   id: 0,
      //   lastId: 155,
      //   title: '',
      //   contents: [
      //     'content1content1content1content1content1content1',
      //     'http://hbxz.qsyhbgj.com/admin/20230406/04.21.jpg',
      //     'content3content3content3content3content3content3content3content3'
      //   ],
      //   showCFlag: false
      // }],
      questionList: [],
      loading: null
    }
  },
  mounted () {
    this.getData(this.lastId1)
  },
  methods: {
    getNextData (clkItem) {
      this.lastIdList.push(Number(clkItem.lastId))
      console.log('clkItem', clkItem)
      this.getData(clkItem.id)
    },
    getLastData () {
      if (this.lastIdList.length !== 1) {
        this.getData(this.lastIdList.pop())
      } else {
        this.$toast.text('没有更多了')
      }
    },
    getData (id) {
      console.log('lastIdList', this.lastIdList)
      console.log(id)
      this.loading = this.$toast.loading()
      api.cdIntelligentSearch({
        type: id
      }).then(res => {
        // console.log('getNextData', res)
        var listTempArr = []
        for (let ti = 0; ti < res.data.list1.length; ti++) {
          listTempArr.push(res.data.list1[ti])
          if (res.data.list2[ti]) { listTempArr.push(res.data.list2[ti]) }
          if (res.data.list3[ti]) { listTempArr.push(res.data.list3[ti]) }
        }
        console.log('listTempArr', listTempArr)
        if (listTempArr.length) {
          var tempArr = []
          listTempArr.forEach(item => {
            var taContents = item.questions.replace(/<\/p>/g, '').split('<p>').filter(tacItem => { return tacItem })
            var taTitle = taContents.shift()
            console.log('ta', taTitle, taContents)
            tempArr.push({
              id: item.id,
              lastId: Number(item.type),
              title: taTitle,
              contents: taContents,
              showCFlag: false
            })
          })
          this.questionList = tempArr
        } else {
          this.lastIdList.pop()
          this.$toast.text('内容持续更新中，暂时没有更多了~')
        }
        this.loading.hide()
      })
    }
  }
}
</script>

<style lang="scss">
.h5-page-eianFAQ {
  background: #f4f5f6;
  max-width: 750px;
  margin: 0 auto;
  .main-title {
    width: 100%;
    padding: 20px 0 20px;
    text-align: center;
  }
  .sth-top {
    border-top: 4px solid #fff;
  }
  .faq-div {
    width: calc(100% - 2 * 20px);
    padding: 10px 20px;
    border-top: 4px solid #fff ;
    h2, h3 {
      margin: 4px 0 4px;
    }
    p {
      line-height: 1.5em;
      text-indent: 2em;
      // padding: 0 1em;
    }
  }
}
</style>
